module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1713782050078,
}